export default __webpack_public_path__ + "static/media/money-active.07a3b242.svg";